// Tiny inline trend chart built on Recharts.

import { ResponsiveContainer, AreaChart, Area } from 'recharts';

function Sparkline({ data = [], dataKey = 'count', color = '#0d9488', height = 36 }) {
  if (!data || data.length === 0) {
    return <div style={{ height }} className="w-full" />;
  }
  const gradientId = `spark-${dataKey}-${color.replace('#', '')}`;
  return (
    <div style={{ height }} className="w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.4} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={2}
            fill={`url(#${gradientId})`}
            isAnimationActive={false}
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default Sparkline;
